import { Flex } from 'foundations-components/components/Flex';
import CommunicationLink from './CommunicationLink';
import DetailsLinkButton from './DetailsLinkButton';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DefaultHoverContent({
  onDetailsClick
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "200",
    flexWrap: "nowrap",
    alignItems: "center",
    marginBlockStart: "250",
    children: [/*#__PURE__*/_jsx(CommunicationLink, {}), /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "detail-100",
      children: /*#__PURE__*/_jsx(DetailsLinkButton, {
        onClick: onDetailsClick
      })
    })]
  });
}